const carouselItems = [
  {
    title: '娱乐圈年度大瓜盘点',
    desc: '回顾过去一年最震撼的娱乐八卦事件，从明星恋情到合约纠纷，一网打尽所有热门吃瓜现场。',
    tag: '年度盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20highlight%20visual%20with%20dramatic%20warm%20lighting%2C%20abstract%20digital%20background%20with%20trending%20topic%20indicators%2C%20modern%20Chinese%20media%20aesthetic%2C%20high%20contrast%20editorial%20style%2C%20coral%20and%20amber%20color%20palette&width=640&height=400&seq=carousel-1&orientation=landscape',
  },
  {
    title: '网红圈最新爆料合集',
    desc: '头部网红不为人知的幕后故事，从直播翻车到人设崩塌，带你深挖网红圈的精彩猛料。',
    tag: '网红爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20drama%20topic%20card%20with%20elegant%20warm%20toned%20abstract%20background%2C%20entertainment%20industry%20visual%20elements%2C%20mysterious%20atmospheric%20composition%20with%20coral%20accents&width=640&height=400&seq=carousel-2&orientation=landscape',
  },
  {
    title: '热门综艺名场面精选',
    desc: '各大综艺节目中最经典的爆笑与争议片段，从选秀舞台到真人秀对决，每一帧都是话题。',
    tag: '综艺精选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20highlight%20visualization%20with%20floating%20hashtag%20elements%20on%20warm%20abstract%20background%2C%20digital%20culture%20aesthetic%2C%20vibrant%20modern%20design%2C%20entertainment%20broadcast%20style&width=640&height=400&seq=carousel-3&orientation=landscape',
  },
  {
    title: '明星私生活大起底',
    desc: '当红明星的私下生活揭秘，从日常穿搭到感情状况，满足你对爱豆的一切好奇心。',
    tag: '明星动态',
    imageUrl: 'https://readdy.ai/api/search-image?query=Celebrity%20lifestyle%20abstract%20visual%20with%20warm%20cinematic%20lighting%2C%20film%20reel%20elements%2C%20sophisticated%20amber%20and%20coral%20color%20palette%2C%20editorial%20photography%20style&width=640&height=400&seq=carousel-4&orientation=landscape',
  },
  {
    title: '社会热点事件追踪',
    desc: '聚焦近期引发全民讨论的社会事件，从争议焦点到最新进展，持续追踪热点动态。',
    tag: '热点追踪',
    imageUrl: 'https://readdy.ai/api/search-image?query=Viral%20social%20topic%20abstract%20visualization%20with%20dynamic%20energy%20waves%20on%20warm%20gradient%2C%20social%20media%20buzz%20aesthetic%2C%20bold%20contemporary%20design%2C%20news%20highlight%20style&width=640&height=400&seq=carousel-5&orientation=landscape',
  },
  {
    title: '影视剧透与幕后花絮',
    desc: '热门影视剧的关键剧透与拍摄幕后故事，从演员选角到剧组秘闻，让你比朋友先知道。',
    tag: '影视揭秘',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20and%20television%20behind%20the%20scenes%20abstract%20visual%20with%20warm%20cinematic%20mood%2C%20camera%20and%20clapperboard%20elements%2C%20sophisticated%20entertainment%20industry%20aesthetic&width=640&height=400&seq=carousel-6&orientation=landscape',
  },
];

const mediaItems = [
  {
    title: '某顶流明星被拍到深夜密会，疑似新恋情曝光',
    views: '128万',
    duration: '03:25',
    tag: '娱乐圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20celebrity%20dating%20rumor%20warm%20evening%20scene%2C%20paparazzi%20style%20abstract%20visual%2C%20mysterious%20atmosphere%20with%20coral%20lighting%2C%20entertainment%20news%20aesthetic&width=640&height=360&seq=media-1&orientation=landscape',
  },
  {
    title: '知名网红直播翻车现场，千万粉丝见证尴尬时刻',
    views: '96万',
    duration: '05:12',
    tag: '网红圈',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20fail%20moment%20abstract%20visual%20with%20dynamic%20dramatic%20warm%20lighting%2C%20digital%20screen%20glitch%20elements%2C%20modern%20streaming%20platform%20aesthetic&width=640&height=360&seq=media-2&orientation=landscape',
  },
  {
    title: '综艺录制现场突发状况，嘉宾当场互怼火药味十足',
    views: '85万',
    duration: '04:38',
    tag: '综艺',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20drama%20moment%20abstract%20visual%20with%20intense%20warm%20studio%20lighting%2C%20confrontational%20atmosphere%2C%20television%20production%20aesthetic%2C%20coral%20and%20amber%20tones&width=640&height=360&seq=media-3&orientation=landscape',
  },
];

const rankingItems = [
  { rank: 1, title: '某女星离婚案内幕曝光，知情人透露更多细节', hot: '🔥 爆', views: '256万' },
  { rank: 2, title: '顶流小生被曝税务问题，工作室紧急回应', hot: '🔥 热', views: '198万' },
  { rank: 3, title: '热门综艺选手私下互撕，节目组沉默引争议', hot: '🔥 热', views: '167万' },
  { rank: 4, title: '某品牌代言人翻车，品牌方连夜发声明切割', hot: '新', views: '142万' },
  { rank: 5, title: '知名导演新片选角内定？多位演员公开质疑', hot: '新', views: '118万' },
  { rank: 6, title: '网红情侣官宣分手，恋爱三年终成陌路', hot: '🔥 热', views: '103万' },
  { rank: 7, title: '某歌手演唱会假唱实锤，现场观众晒证据', hot: '', views: '89万' },
];

export function CarouselSection() {
  return (
    <section id="carousel" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">焦点专题</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">本周最值得关注的吃瓜话题</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.imageUrl}
              href="#media"
              className="group block bg-background-50 border border-background-200/60 rounded-lg overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500 text-white text-[10px] md:text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-1">{item.title}</h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">精彩视频</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">热门吃瓜视频精选推荐</p>
        <div className="mt-6 md:mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {mediaItems.map((item) => (
            <a
              key={item.imageUrl}
              href="#media"
              className="group block bg-background-100 border border-background-200/60 rounded-lg overflow-hidden transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <span className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white/90 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-primary-500 text-lg md:text-xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-black/60 text-white text-[10px] md:text-xs font-medium">
                  {item.duration}
                </span>
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-white text-[10px] md:text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-bold text-foreground-900 line-clamp-2 leading-snug">{item.title}</h3>
                <div className="mt-2 flex items-center gap-1.5 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RankingSection() {
  return (
    <section id="ranking" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <h2 className="text-xl md:text-2xl font-black text-foreground-950 text-center">吃瓜热榜</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时更新 · 全网热度排名</p>
        <div className="mt-6 md:mt-8 max-w-3xl mx-auto">
          <div className="bg-background-50 border border-background-200/60 rounded-lg overflow-hidden">
            {rankingItems.map((item, i) => (
              <a
                key={i}
                href="#media"
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3 md:py-3.5 transition-colors hover:bg-background-100 cursor-pointer ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <span
                  className={`shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center text-xs md:text-sm font-black ${
                    item.rank === 1
                      ? 'bg-primary-500 text-white'
                      : item.rank === 2
                      ? 'bg-accent-500 text-white'
                      : item.rank === 3
                      ? 'bg-secondary-500 text-white'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 text-sm md:text-base font-medium text-foreground-800 line-clamp-1">
                  {item.title}
                </span>
                {item.hot && (
                  <span className={`shrink-0 px-1.5 py-0.5 rounded text-[10px] md:text-xs font-medium whitespace-nowrap ${
                    item.hot.includes('爆') ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                  }`}>
                    {item.hot}
                  </span>
                )}
                <span className="shrink-0 text-xs text-foreground-400 whitespace-nowrap">{item.views}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}